import { render } from "./TaskItemInbox.vue?vue&type=template&id=32431569"
import script from "./TaskItemInbox.vue?vue&type=script&lang=js"
export * from "./TaskItemInbox.vue?vue&type=script&lang=js"

import "./TaskItemInbox.vue?vue&type=style&index=0&id=32431569&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__